const names = {
  gold: "بسته پیشرفته",
  silver: "بسته نقره‌ای",
  bronze: "بسته پایه",
};

export default names;
